import { StandardTheme } from "./Standard";

export const Themes = {
    StandardTheme,
};

export default Themes;
